/**
 * React 入口。
 * 挂载 + 全局样式 + Toast Provider（`ToastHost` 在 `App.tsx` 内渲染）。
 */

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import App from '@/App';
import { ModulesProvider } from '@/config/AppModules';
import '@/styles/globals.css';

const containerEl = document.getElementById('root');
if (!containerEl) throw new Error('#root 未找到，请检查 index.html');

createRoot(containerEl).render(
  <StrictMode>
    <BrowserRouter>
      <ModulesProvider>
        <App />
      </ModulesProvider>
    </BrowserRouter>
  </StrictMode>,
);

// PWA：注册离线壳（/sw.js，网络优先 + 缓存兜底）。失败静默——不影响应用可用性。
if (typeof navigator !== 'undefined' && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/sw.js').catch(() => undefined);
  });
}
